@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';

.announcement-banner {
  height: 2rem;
  background-color: $color-purple-default;
  display: flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;

  @include breakpoint('xs', 'sm') {
    padding: 0.5rem 1rem;
    height: unset;
  }

  &-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;

    @include breakpoint('xs', 'sm') {
      justify-content: space-between;
      width: 100%;
    }

    &-mainText-wrapper {
      display: flex;
      justify-content: flex-start;
      gap: 0.25rem;

      @include breakpoint('xs', 'sm') {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    &-mainText {
      color: #fff;
      font-family: $typography-family-sans;
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5;

      @include breakpoint('xs', 'sm') {
        font-size: 0.875rem;
      }
    }

    &-cta-wrapper {
      display: flex;
      justify-content: flex-end;
    }

    &-cta {
      color: #fff;
      font-family: $typography-family-sans;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1.5;
      text-decoration: underline;

      @include breakpoint('xs', 'sm') {
        font-size: 0.875rem;
      }
    }
  }
} 

#announcement-banner-promo-terms {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 1.5rem;
  font-family: $typography-family-sans;
  margin: 0 auto;

  @include breakpoint('md') {
    max-width: 63rem;
  }
}
